export function formatDate(dateStr: string): string {
  const parts = dateStr.split("-");
  if (parts.length !== 3) return dateStr;
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
}

export function formatShortDate(dateStr: string): string {
  const parts = dateStr.split("-");
  if (parts.length !== 3) return dateStr;
  return `${Number(parts[1])}月${Number(parts[2])}日`;
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return String(views);
}

export function relativeTime(dateStr: string, now: Date = new Date()): string {
  const target = new Date(`${dateStr}T12:00:00`);
  const diff = now.getTime() - target.getTime();
  const day = 24 * 60 * 60 * 1000;
  if (diff < day && diff >= 0) return "今天";
  if (diff < 2 * day && diff >= 0) return "昨天";
  const days = Math.floor(diff / day);
  if (days < 30) return `${days}天前`;
  return formatShortDate(dateStr);
}